module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Spring length")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.springLength),
      expression: "settings.springLength"
    }],
    domProps: {
      "value": (_vm.settings.springLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.springLength = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Spring Coeff")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.springCoeff),
      expression: "settings.springCoeff"
    }],
    domProps: {
      "value": (_vm.settings.springCoeff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.springCoeff = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Gravity")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.gravity),
      expression: "settings.gravity"
    }],
    domProps: {
      "value": (_vm.settings.gravity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.gravity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Theta")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.theta),
      expression: "settings.theta"
    }],
    domProps: {
      "value": (_vm.settings.theta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.theta = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Drag coefficient")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.dragCoeff),
      expression: "settings.dragCoeff"
    }],
    domProps: {
      "value": (_vm.settings.dragCoeff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.dragCoeff = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Time step")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timeStep),
      expression: "settings.timeStep"
    }],
    domProps: {
      "value": (_vm.settings.timeStep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.timeStep = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-712134ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NLayoutSettings.vue
// module id = 239
// module chunks = 1